import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material';
import { DialogComponent } from './dialog/dialog.component';
import { FuseUploadService } from './upload.service';
import { UploadOptions } from './upload.model';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
    selector: 'fuse-upload',
    templateUrl: './upload.component.html',
    styleUrls: ['./upload.component.scss'],
})
export class FuseUploadComponent implements OnInit, OnDestroy {

    private _unsubscribeAll: Subject<any>;

    @Input() uploadOptions: UploadOptions;

    lang = 'sr';

    constructor(
        public dialog: MatDialog,
        public uploadService: FuseUploadService,
        private _translate: TranslateService,
        private _translationLoader: FuseTranslationLoaderService
    ) {
        // this.uploadOptions.buttonTitle = this._translate.instant('Upload');
        this._unsubscribeAll = new Subject();
     }

    public openUploadDialog(): void {
        const dialogRef = this.dialog.open(DialogComponent, {
            panelClass: 'fuse-upload-dialog',
            data: {
                options: this.uploadOptions
            }
        });
    }


    private getTranslations(): void {
        this._translationLoader.getLastLang()
            .then(response => {
                this.lang = response['code'];
                this._translationLoader.getTranslations(this.lang, '6');
            })
            .catch(err => Promise.reject(err))
            .then(() => {
            }, err => {
            });
    }

    ngOnInit(): void {
        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(value => {
                this.getTranslations();
            });
        this.getTranslations();

    }


    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

}
